import { render, staticRenderFns } from "./DialogCopy.vue?vue&type=template&id=31dbf3da&scoped=true&"
import script from "./DialogCopy.vue?vue&type=script&lang=js&"
export * from "./DialogCopy.vue?vue&type=script&lang=js&"
import style0 from "./DialogCopy.vue?vue&type=style&index=0&id=31dbf3da&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dbf3da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VBtn,VCardActions,VCol,VContainer,VDialog,VRow,VSpacer})
